import { h } from '@stencil/core';

enum HeadingVariant {
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'subtitle-s',
  'body-1',
  'body-2',
  'button',
  'caption',
  'overline-1',
  'overline-2',
  'p',
  'link',
  'link-underline',
}

interface Heading {
  className?: string;
  tag?: string;
  text: string;
  variant: HeadingVariant | string;
}

export default function Heading({ text, variant, tag, className }: Heading) {
  let useTag = 'span';

  if (/^h[1-6]$/.test(variant as string)) {
    useTag = variant as string;
  }
  if (variant === 'link') {
    useTag = 'a';
  }
  if (tag) {
    useTag = tag;
  }

  return h(useTag, { className: `eva-3-${variant} ${className ?? ''}` }, text);
}
